document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll('.js-accordion > a');
    items.forEach((item) => {
        item.addEventListener('click', function (event) {
            event.preventDefault();

            const items = document.querySelectorAll('.js-accordion');
            items.forEach((item) => {
                if(item != this.parentElement) item.classList.remove('accordion--open');
            });
            this.parentElement.classList.toggle('accordion--open');
        });
    });
});
